import React from "react";
import { Box } from "@mui/material";
import { styled } from "@mui/system";
import FocusCorners from "./FocusCorners"; // 假设你已经创建了 FocusCorners 组件

const StyledButton = styled(Box)(({ theme }) => ({
  minHeight: "50px",
  minWidth: "168px",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "16px",
  lineHeight: "22px",
  textAlign: "center",
  letterSpacing: "0.08em",
  transition: "318ms ease-in-out",
  cursor: "pointer",
  borderRadius: "4px",
  userSelect: "none",
  width: "100%",
  color: "#fff",
  "&:hover": {
    backgroundColor: "var(--brand)",
    color: "var(--secondary)",

    "& .focus-corners": {
      "--corner-margin": "6px"
    }
  },
  "&:active": {
    transform: "scale(0.97)"
  },
  "&.active": {
    background: ` rgba(255, 135, 54, 0.4)`,
    "background-blend-mode": "soft-light, normal, normal",
    color: "#fff",

    "& .focus-corners": {
      "--corner-color": "var(--brand)",
      "--corner-margin": "0"
    }
  }
}));

const FocusGhostButton = ({ children, ...props }) => {
  return (
    <StyledButton {...props}>
      <FocusCorners>{children}</FocusCorners>
    </StyledButton>
  );
};

export default FocusGhostButton;
